import { cn } from "@/utils/cn";
import { memo } from "react";

/**
 * Decorative background gradient element positioned behind main content
 */
export const BackgroundGradient = memo(function BackgroundGradient() {
  return (
    <div
      className={cn(
        "fixed right-0 left-0 z-10 h-full w-full",
        "top-[calc(var(--safe-area-inset-top)+98px)]",
        "pointer-events-none rounded-[354.239px_354.239px_0_0] opacity-20 blur-[50px]",
        "bg-gradient-to-b from-[#7A28EE] from-0% to-[#7A28EE]",
      )}
    />
  );
});
